import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { AppStore } from '../reducers/types';

export const useReduxSelector: TypedUseSelectorHook<AppStore> = useSelector;
